import React, { useEffect, useState } from "react";
import GlobalCard from "../../components/GlobalCardComponent";
import {
  Backdrop,
  Box,
  Button,
  Card,
  Chip,
  Grid,
  Link,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";

import PinkSmallButton from "../../components/customButtons/PinkSmallButton";
import {
  getEvaluationData,
  getPastDemos,
  getUpcommingDemos,
} from "../testPrepDashboard/Api/DashboardApi";
import Loader from "../../../SAPPages/components/Loader/Loader";
import { fDate } from "../../../utils2/formatTime";
import CustomPopup from "../../components/customPopup/CustomPopup";
import RescheduleDemoScreen from "./RescheduleDemoScreen";
import NoUpcomingDemoPage from "./NoUpcomingDemoPage";
import NoPastDemoPage from "./NoPastDemoPage";
import PinkLightButton from "../../components/customButtons/PinkLightButton";
import CancelDemoForm from "./CancelDemoForm";
import PinkExtraSmallButton from "../../components/customButtons/PinkExtraSmallButton";
import PinkLightExtraButton from "../../components/customButtons/PinkLightExtraSmall";
import ConfimationPopup from "../../components/customPopup/ConfimationPopup";
import GlobalMessageModal from "../../components/customPopup/GlobalMessageModal";
import ArticleIcon from "@mui/icons-material/Article";
import DoneIcon from "@mui/icons-material/Done";
import LaptopIcon from "@mui/icons-material/Laptop";
import { useNavigate } from "react-router-dom";
import ErrorPopupScreen from "../../components/customPopup/ErrorPopupScreen";

import { pdf } from "@react-pdf/renderer";
import DownloadEvalutionReport from "./DownloadEvalutionReport";
export default function ViewDemoHistory() {
  const userId = localStorage.getItem("userId");
  const firstName = localStorage.getItem("firstName");
  const lastName = localStorage.getItem("lastName");
  const [selected, setSelected] = useState("upcoming");
  const [demoData, setDemoData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewDemoPopup, setViewDemoPopu] = useState(false);
  const [cancelPopup, setCanelPopup] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const currentDate = new Date().toISOString().split("T")[0];
  const currentTime = new Date().toTimeString().slice(0, 5);
  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  const [openCancelSuccessPopup, setOpenCanceSuccesPopup] = useState(false);
  const [evaluationLoading, setEvaluationLoading] = useState(false);
  const [evalutionData, setEvaluationData] = useState([]);
  const [errorMessage, setMessageError] = useState(null);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [copied, setCopied] = useState(false);

  const navigate = useNavigate();
  // Fetch Past and upcomming demos
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let data;
        if (selected === "upcoming") {
          data = await getUpcommingDemos(userId);
        } else if (selected === "past") {
          data = await getPastDemos(userId);
        }
        setDemoData(data?.data);
      } catch (err) {
        console.error("Could not fetch user details", err);
      } finally {
        setLoading(false);
      }
    };

    if (userId && selected) {
      fetchData();
    }
  }, [userId, selected]);

  const handleOpenReschedulePopup = (data) => {
    setViewDemoPopu(true);
    setSelectedData(data);
  };

  const handleCloseReschedulePopup = () => {
    setViewDemoPopu(false);
  };

  // cancel popup
  const handleOpenCancelPopup = (data) => {
    console.log("data", data);
    setCanelPopup(true);
    setSelectedData(data);
  };

  const handleCloseCancelPopup = () => {
    setCanelPopup(false);
  };

  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);

  const handleOpenCancelSuccessPopup = () => setOpenCanceSuccesPopup(true);
  const handleCloseCancelSuccessPopup = () => setOpenCanceSuccesPopup(false);

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  const getEvalutionReport = async (evaluationId) => {
    setEvaluationLoading(true);
    try {
      const payload = {
        id: evaluationId,

        user_id: parseInt(userId),
      };

      const response = await getEvaluationData(payload);
      if (response.status === 200) {
        setEvaluationData(response?.data);
        // Store the evaluation data in sessionStorage (unique key for each evaluation)
        const storageKey = `evaluationData_${evaluationId}`;
        sessionStorage.setItem(storageKey, JSON.stringify(response.data));

        // Open the evaluation report in a new tab
        const url = `/test-prep/evaluation-report/${evaluationId}`;
        window.open(url, "_blank");
        setEvaluationLoading(false);
      } else if ([400, 401, 500].includes(response.status)) {
        setEvaluationLoading(false);
        setMessageError(response?.message);
      }
    } catch (error) {
      setEvaluationLoading(false);
      setMessageError("Internal Server Error");
      navigate("/page500");
    }
  };

  const handleNavigateToClass = (classData) => {
    navigate("/test-prep/packages", {
      state: { classData },
    });
  };

  const downloadEvalutionpdf = async (evaluationId) => {
    setEvaluationLoading(true);
    try {
      const payload = {
        id: evaluationId,

        user_id: parseInt(userId),
      };

      const response = await getEvaluationData(payload);
      if (response.status === 200) {
        setEvaluationData(response?.data);
        const blob = await pdf(
          <DownloadEvalutionReport evalutionData={response?.data} />
        ).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${firstName}_${lastName}_Evalution_Report.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        setEvaluationLoading(false);
      } else if ([400, 401, 500].includes(response.status)) {
        setEvaluationLoading(false);
        setMessageError(response?.message);
      }
    } catch (error) {
      setEvaluationLoading(false);
      setMessageError("Internal Server Error");
      navigate("/page500");
    }
  };

  const handleCopyLink = (data) => {
    if (data?.class_id?.zoom_link) {
      navigator.clipboard.writeText(
        "https://zoom.us/j/97485138279?pwd=Y1cwcXRHUWZWOFN3aTZOdmhHZm4yQT09#success"
      );
      setCopied(true);

      // Reset copied status after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    }
  };

  console.log("copied", copied);
  return (
    <>
      <Backdrop open={evaluationLoading} style={{ zIndex: 9999 }}>
        <Loader text="Genarting Evalution Report..." />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "inline-flex",
              backgroundColor: "#f5f5f5",
              borderRadius: "12px",
              p: "2px",
            }}
          >
            <Button
              onClick={() => setSelected("upcoming")}
              sx={{
                textTransform: "none",
                fontWeight: 500,
                m: 0.5,
                px: 3,
                borderRadius: "8px",
                minHeight: "32px",
                fontFamily: "Inter",
                fontSize: "14px",
                color: selected === "upcoming" ? "#fff" : "#3F424C",
                backgroundColor:
                  selected === "upcoming" ? "#572575" : "transparent",
                "&:hover": {
                  backgroundColor:
                    selected === "upcoming" ? "#572575" : "rgba(0,0,0,0.04)",
                },
              }}
            >
              Upcoming Demo
            </Button>

            <Button
              onClick={() => setSelected("past")}
              sx={{
                textTransform: "none",
                fontWeight: 500,
                m: 0.5,
                px: 3,
                borderRadius: "8px",
                minHeight: "32px",
                fontFamily: "Inter",
                fontSize: "14px",
                color: selected === "past" ? "#fff" : "#3F424C",
                backgroundColor:
                  selected === "past" ? "#572575" : "transparent",
                "&:hover": {
                  backgroundColor:
                    selected === "past" ? "#572575" : "rgba(0,0,0,0.04)",
                },
              }}
            >
              Past Demo
            </Button>
          </Box>
        </Grid>

        {loading ? (
          <Grid item xs={12}>
            <Loader text="Loading Demos..." />
          </Grid>
        ) : demoData?.length > 0 ? (
          demoData.map((data, index) => {
            const startTime = data?.slot?.split("-")[0];
            const endTime = data?.slot?.split("-")[1];
            const joinButtonCondition =
              data?.status === "confirmed" &&
              data?.delivery_mode === "online" &&
              currentDate === data?.available_demo_date &&
              currentTime >= startTime &&
              currentTime <= endTime;
            return (
              <>
                <Grid item xs={12} key={data?._id || index}>
                  <GlobalCard>
                    <Card
                      sx={{
                        borderRadius: "12px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                        borderLeft: "3px solid #DA5DC7", // purple left border
                        mb: 2,
                        p: "10px",
                      }}
                    >
                      {/* Header Row */}
                      <Box display="flex" flexDirection="column">
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Box display="flex" alignItems="center" mb={2}>
                            <Typography
                              color="#9D0385"
                              fontFamily="Inter"
                              fontSize="16px"
                              lineHeight="100%"
                              letterSpacing="0px"
                              fontWeight={700}
                            >
                              {data?.class_id?.name} |
                            </Typography>

                            <Chip
                              label={data?.status}
                              size="small"
                              sx={{
                                fontWeight: 600,
                                px: 1,
                                ml: 1,
                                borderRadius: "4px",
                                fontFamily: "Inter",
                                fontSize: "14px",

                                ...(data?.status === "confirmed" && {
                                  backgroundColor: "#E6F4EA",
                                  color: "#077E2B",
                                }),
                                ...(data?.status === "completed" && {
                                  backgroundColor: "#E3F2FD",
                                  color: "#1565C0",
                                }),
                                ...(data?.status === "cancelled" && {
                                  backgroundColor: "#FFEBEE",
                                  color: "#C62828",
                                }),
                                ...(data?.status === "missed" && {
                                  backgroundColor: "#FFF3E0",
                                  color: "#EF6C00",
                                }),
                              }}
                            />
                          </Box>

                          <Box
                            display="inline-flex"
                            alignItems="center"
                            gap={1}
                            px={1.5}
                            py={0.5}
                            backgroundColor={
                              data?.delivery_mode === "online"
                                ? "#DBEDFF"
                                : "#FFEADE"
                            }
                            borderRadius="8px"
                          >
                            <Box
                              sx={{
                                width: "8px",
                                height: "8px",
                                backgroundColor:
                                  data?.delivery_mode === "online"
                                    ? "#007BFF"
                                    : "#E65100",
                                borderRadius: "50%",
                              }}
                            />
                            <Typography
                              fontSize="12px"
                              color={
                                data?.delivery_mode === "online"
                                  ? "#007BFF"
                                  : "#E65100"
                              }
                              textTransform="capitalize"
                            >
                              {data?.delivery_mode}
                            </Typography>
                          </Box>
                        </Box>

                        {/* Details Grid */}
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={2}>
                            <Typography color="text.secondary" fontSize="16px">
                              Test Type
                            </Typography>
                            <Typography
                              color="#000000"
                              fontFamily="Inter"
                              fontSize="15px"
                              lineHeight="100%"
                              letterSpacing="0px"
                              fontWeight={400}
                              mt={1}
                            >
                              {data?.test_type_id?.name}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={2}>
                            <Typography color="text.secondary" fontSize="16px">
                              Trainer Name
                            </Typography>
                            <Typography
                              color="#000000"
                              fontFamily="Inter"
                              fontSize="15px"
                              lineHeight="100%"
                              letterSpacing="0px"
                              fontWeight={400}
                              mt={1}
                            >
                              {data?.trainer_id?.first_name}{" "}
                              {data?.trainer_id?.last_name}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={3}>
                            <Typography color="text.secondary" fontSize="16px">
                              Demo Date & Time
                            </Typography>
                            <Typography
                              color="#000000"
                              fontFamily="Inter"
                              fontSize="15px"
                              lineHeight="100%"
                              letterSpacing="0px"
                              fontWeight={400}
                              mt={1}
                            >
                              {fDate(data?.available_demo_date)}, {data?.slot}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={2} mt={1}>
                          {data?.delivery_mode === "offline" && (
                            <Grid item xs={12} md={2}>
                              <Typography
                                color="text.secondary"
                                fontSize="16px"
                              >
                                Branch
                              </Typography>
                              <Typography
                                color="#000000"
                                fontFamily="Inter"
                                fontSize="15px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontWeight={400}
                                mt={1}
                              >
                                {data?.branch_id?.branch_name}
                              </Typography>
                            </Grid>
                          )}

                          {data?.delivery_mode === "online" && (
                            <Grid item xs={12} md={2}>
                              <Typography
                                color="text.secondary"
                                fontSize="16px"
                              >
                                Copy Link
                              </Typography>

                              <Typography
                                color="#000000"
                                fontFamily="Inter"
                                fontSize="15px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontWeight={400}
                                mt={1}
                              >
                                {/* Copy Link button */}
                                {data?.class_id?.zoom_link && (
                                  <Typography
                                    onClick={() => {
                                      if (!joinButtonCondition) {
                                        setMessageError(
                                          "You can copy the demo link only during the scheduled time."
                                        );
                                        handleOpenErrorPopup();
                                        return;
                                      }
                                      handleCopyLink(data);
                                    }}
                                    sx={{
                                      color: copied ? "green" : "#007aff",
                                      fontSize: "16px",
                                      fontWeight: 400,
                                      cursor: "pointer",
                                    }}
                                  >
                                    {copied ? "Copied!" : "Link Here"}
                                  </Typography>
                                )}
                              </Typography>

                              <Typography
                                sx={{
                                  color: "#000000",
                                  fontSize: "16px",
                                  fontWeight: 400,
                                  cursor: "pointer",
                                  ml: 1,
                                }}
                              >
                                —
                              </Typography>
                            </Grid>
                          )}

                          {/* {data?.delivery_mode === "offline" && (
                          <Grid item xs={12} md={2}>
                            <Typography color="text.secondary" fontSize="16px">
                              Room Number
                            </Typography>
                            <Typography
                              color="#000000"
                              fontFamily="Inter"
                              fontSize="15px"
                              lineHeight="100%"
                              letterSpacing="0px"
                              fontWeight={400}
                              mt={1}
                            >
                              {data?.class_id?.id}
                            </Typography>
                          </Grid>
                        )} */}

                          <Grid item xs={12} md={4}>
                            <Typography color="text.secondary" fontSize="16px">
                              Address
                            </Typography>
                            {data?.delivery_mode === "offline" && (
                              <Typography
                                color="#000000"
                                fontFamily="Inter"
                                fontSize="15px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontWeight={400}
                                mt={1}
                              >
                                {data?.branch_id?.address}
                              </Typography>
                            )}

                            {data?.delivery_mode === "online" && (
                              <Typography
                                color="#000000"
                                fontFamily="Inter"
                                fontSize="15px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontWeight={400}
                                mt={1}
                              >
                                Online Class
                              </Typography>
                            )}
                          </Grid>

                          <Grid item xs={12} md={6} mt={2}>
                            <Grid container gap={2} justifyContent="flex-end">
                             {selected === "upcoming"  && (
                              <>
                              <PinkExtraSmallButton
                                buttonTitle="Reschedule"
                                onClick={() => {
                                  if (
                                    currentDate >= data?.available_demo_date
                                  ) {
                                    setMessageError(
                                      "You can reschedule your demo only up to one day before the scheduled date."
                                    );
                                    handleOpenErrorPopup();
                                    return;
                                  }
                                  handleOpenReschedulePopup(data);
                                }}
                              />
                             <PinkLightExtraButton
  buttonTitle="Cancel"
  onClick={() => {
    // Parse the demo date
    const demoDate = new Date(data.available_demo_date); 
    // Example: 2025-11-28

    // Parse the demo start time: e.g. "14:30"
    const [hours, minutes] = startTime.split(":").map(Number);

    // Build the full demo start datetime
    const startDateTime = new Date(
      demoDate.getFullYear(),
      demoDate.getMonth(),
      demoDate.getDate(),
      hours,
      minutes
    );

    // The last allowed cancellation time = 1 hour before start
    const oneHourBefore = new Date(startDateTime.getTime() - 60 * 60 * 1000);

    const now = new Date();

    // Allow cancel if current time is BEFORE (start - 1 hr)
    if (now <= oneHourBefore) {
      handleOpenCancelPopup(data);
    } else {
      setMessageError(
        "You can cancel your demo only up to one hour before the scheduled start time."
      );
      handleOpenErrorPopup();
    }
  }}
/>

                              {data?.mode_of_delivery==="online" && ( 
                              <PinkExtraSmallButton
                                buttonTitle="Join"
                                onClick={() => {
                                  if (!joinButtonCondition) {
                                    setMessageError(
                                      "You can join the demo only during the scheduled time."
                                    );
                                    handleOpenErrorPopup();
                                    return;
                                  }
                                  window.open(
                                    data?.class_id?.zoom_link,
                                    "_blank",
                                    "noopener,noreferrer"
                                  );
                                }}
                              />
                              )}
                              </>
                               )}

                              {data?.status === "completed" &&
                                data?.evaluation_id !== null && (
                                  <>
                                    <PinkExtraSmallButton
                                      buttonTitle="View Evaluation Report"
                                      onClick={() =>
                                        getEvalutionReport(data?.evaluation_id)
                                      }
                                    />

                                    <PinkExtraSmallButton
                                      buttonTitle="Enroll Now"
                                      onClick={() =>
                                        handleNavigateToClass(data?.class_data)
                                      }
                                    />
                                    <Tooltip title="Download Report">
                                      <Box
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          downloadEvalutionpdf(
                                            data?.evaluation_id
                                          )
                                        }
                                      >
                                        <img
                                          src="/newdashboard/Demo/ic_round-download (1).png"
                                          style={{ width: 30 }}
                                        />
                                      </Box>
                                    </Tooltip>
                                  </>
                                )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Card>
                  </GlobalCard>
                </Grid>
              </>
            );
          })
        ) : selected === "upcoming" ? (
          <Grid item xs={12}>
            <NoUpcomingDemoPage />
          </Grid>
        ) : (
          <Grid item xs={12}>
            <NoPastDemoPage />
          </Grid>
        )}
      </Grid>

      <CustomPopup
        handleClose={handleCloseReschedulePopup}
        component={
          <RescheduleDemoScreen
            handleClose={handleCloseReschedulePopup}
            selectedData={selectedData}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
          />
        }
        open={viewDemoPopup}
        maxWidth="md"
      />

      <CustomPopup
        handleClose={handleCloseCancelPopup}
        component={
          <CancelDemoForm
            handleClose={handleCloseCancelPopup}
            selectedData={selectedData}
            handleOpenSuccessPopup={handleOpenCancelSuccessPopup}
          />
        }
        open={cancelPopup}
        maxWidth="sm"
      />

      <ConfimationPopup
        handleClose={handleCloseSuccessPopup}
        component={
          <GlobalMessageModal
            handleClose={handleCloseSuccessPopup}
            const
            text="Demo Rescheduled Successfully ! !."
            subText="Your demo class has been rescheduled to the selected slot."
            buttonTitle="Thanks, Got it"
            startIcon={<DoneIcon />}
            navigateLink="/test-prep/demos"
            currentLink="/test-prep/demos"
          />
        }
        open={openSuccesPopup}
        subtitle=""
        maxWidth="sm"
      />

      <ConfimationPopup
        handleClose={handleCloseCancelSuccessPopup}
        component={
          <GlobalMessageModal
            handleClose={handleCloseCancelSuccessPopup}
            const
            text="Cancellation Confirmed."
            subText="Your demo has been successfully canceled and removed from your schedule"
            buttonTitle="Book another Demo"
            startIcon={<LaptopIcon />}
            navigateLink="/test-prep/demos"
            currentLink="/test-prep/demos"
          />
        }
        open={openCancelSuccessPopup}
        subtitle=""
        maxWidth="sm"
      />
      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle="Got It"
        // startIcon={<ArticleIcon />}
        // navigateLink="/test-prep/checkout"
        // currentPathname={location.pathname}
        maxWidth="xs"
      />
    </>
  );
}
